import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage/HomePage';
import AnalyticsRouteListener from './components/AnalyticsRouteListener';

const FormPage = lazy(async () => await import('./pages/FormPage'));

function App (): JSX.Element {
  return (
    <Router basename="/">
      <div className="App">
        <AnalyticsRouteListener />
        <Suspense
          fallback={
            <p className="py-16 text-center text-muted">Loading…</p>
          }
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/appointments" element={<FormPage />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
